import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VTooltip,{attrs:{"bottom":"","color":"#311B92"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"block-icon mr-2",on:{"click":function($event){$event.stopPropagation();return _vm.FacuresToConfirme.apply(null, arguments)}}},'div',attrs,false),on),[_c('IconBadgeCheck')],1)]}}])},[_c('span',[_vm._v("Valider des factures")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }